import Vue from "vue";
export const snackBarEventBus = new Vue();
export const snackBarEventName = "show";
